import { createIcon } from '@consta/icons/Icon'
import type { SVGProps } from 'react'

function IconToggleUpS(props: SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 18 6" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.8942 5.45768C17.6472 5.94211 17.0466 6.13847 16.5526 5.89625L9 2.19285L1.4474 5.89625C0.953432 6.13847 0.352772 5.94211 0.10579 5.45768C-0.141194 4.97325 0.0590249 4.38419 0.552991 4.14197L9 0L17.447 4.14197C17.941 4.38419 18.1412 4.97325 17.8942 5.45768Z"
        fill="var(--color-typo-primary)"
        fillOpacity="0.3"
      />
    </svg>
  )
}

export const IconToggleUp = createIcon({
  l: IconToggleUpS,
  m: IconToggleUpS,
  s: IconToggleUpS,
  xs: IconToggleUpS,
  name: 'IconToggleUp',
})
